import { FC } from 'react';
import { Typography } from 'shared/ui/typography';
import { CardContent } from './styles';
import { BasicCard } from 'shared/ui/cards/basicCard';

export const OrderTimeHeader: FC<{ time: string }> = ({ time }) => {
	return (
		<BasicCard variant="info" styles={{ borderRadius: '0px', borderTopLeftRadius: '12px', borderTopRightRadius: '12px' }}>
			<CardContent>
				<Typography mode="large">{time}</Typography>
			</CardContent>
		</BasicCard>
	);
};
